// extracted by mini-css-extract-plugin
module.exports = {"poll":"Poll_poll__17g9F"};